import UrlHelpers from "shared/util/UrlHelpers";

// Looks for a userid in the active window location.
// By default looks at profile page path & userid query string.
// Options:
// - altQueryParams [String] - array of additional query parameters to check.
export default function GetUserIdFromWindowLocation({
	location = window.location,
	...options
} = {}) {
	let userid;

	// Extract it from the profile URL.
	const currentPath = location.pathname || "";

	if (currentPath.indexOf("/profile/") === 0) {
		// This will get whatever comes after /profile/ (but before the next /).
		[ userid ] = currentPath.replace("/profile/", "").split("/");

		return userid;
	}

	// Try to get userid query param as a last resort.
	userid = UrlHelpers.getParam("userid");

	// Additional places to check.
	if (!userid && options && options.altQueryParams) {
		const queryParam = options.altQueryParams.find((q) => UrlHelpers.getParam(q));
		userid = UrlHelpers.getParam(queryParam);
	}

	return userid;
}



// WEBPACK FOOTER //
// ./src/shared/util/GetUserIdFromWindowLocation.js